/**
 * Timing copied from the original external HTML opening animation.
 *
 * The last two stages are deliberately kept here instead of being hidden in
 * CSS: the Canvas particle renderer needs the same event boundaries for the
 * frame impact and the two diving-missile effects.
 */
export const BIRTH_TIMING = Object.freeze({
  heartbeatEnd: 1100,
  heartBurstEnd: 1500,
  babyEnd: 3000,
  frameEnd: 5000,
  textEnd: 7800,
  fullEnd: 8700,
  reducedEnd: 700
})
export type BirthPhase = 'heartbeat' | 'heart-burst' | 'baby' | 'frame' | 'text' | 'fade' | 'reduced'
export function getBirthPhase(elapsed: number, reducedMotion: boolean): BirthPhase {
  if (reducedMotion) return 'reduced'
  if (elapsed < BIRTH_TIMING.heartbeatEnd) return 'heartbeat'
  if (elapsed < BIRTH_TIMING.heartBurstEnd) return 'heart-burst'
  if (elapsed < BIRTH_TIMING.babyEnd) return 'baby'
  if (elapsed < BIRTH_TIMING.frameEnd) return 'frame'
  if (elapsed < BIRTH_TIMING.textEnd) return 'text'
  return 'fade'
}
